import { formatString } from '../../../assets/js/utils/formatString';

function getAmountInputError(inputEl, unitData, resourcedTexts) {
    const { validity } = inputEl;

    if (validity.valueMissing) {
        return resourcedTexts.amountErrorValueMissing;
    }

    if (!validity.valid) {
        const { min, max, multiplier } = unitData;
        const hasMultiplier = multiplier && multiplier > 1;
        const hasMax = max > 0; // 0 means there is no max

        if (min && hasMax && hasMultiplier) {
            return formatString(resourcedTexts.amountIncorrectValueMinMaxSteps, [min, max, multiplier]);
        }
        if (min && hasMax) {
            return formatString(resourcedTexts.amountIncorrectValueMinMax, [min, max]);
        }

        if (min && hasMultiplier) {
            return formatString(resourcedTexts.amountIncorrectValueMinMultiplier, [min, multiplier]);
        }

        return formatString(resourcedTexts.amountIncorrectValueMin, [min]);
    }

    return null;
}

export { getAmountInputError };
